import { render, staticRenderFns } from "./selectClientProductDialog.vue?vue&type=template&id=0c81d9a0&scoped=true&"
import script from "./selectClientProductDialog.vue?vue&type=script&lang=js&"
export * from "./selectClientProductDialog.vue?vue&type=script&lang=js&"
import style0 from "./selectClientProductDialog.vue?vue&type=style&index=0&id=0c81d9a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c81d9a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\shop-admin-vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c81d9a0')) {
      api.createRecord('0c81d9a0', component.options)
    } else {
      api.reload('0c81d9a0', component.options)
    }
    module.hot.accept("./selectClientProductDialog.vue?vue&type=template&id=0c81d9a0&scoped=true&", function () {
      api.rerender('0c81d9a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/crm/components/base/selectClientProductDialog.vue"
export default component.exports